import { Center, Loader, Paper, Table, Text, Title, createStyles } from "@mantine/core"
import { formatDateTime, formatObservationValue } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";


const useStyles = createStyles((theme) => ({
    table: {
        marginTop: "30px"
    },
    thead: {
        backgroundColor: '#BEDEF8',
        borderRadius: 4,
    },
}));

export const Observation = () => {
    const { patientId } = useParams()
    const { classes } = useStyles();
    const medplum = useMedplum();
    const [observations, setObservations] = useState<any>([]);
    const [isFetching, setIsFetching] = useState<boolean>(true);
    const tableHeaders = ["Observation Name", "Category", "Date Issued", "Reference Range", "Effective Date", "Status"]


    useEffect(() => {
        getObservations()
    }, [patientId])

    const getObservations = async () => {
        const res = await medplum.searchResources('Observation', `patient=Patient/${patientId}&_sort=-date`)
        setIsFetching(false)
        setObservations(res)
    }

    const getCategory = (category: any) => {
        let text = ""
        if (category?.length > 0) {
            for (let i = 0; i < category.length; i++) {
                if (category[i].coding) {
                    for (let j = 0; j < category[i].coding.length; j++) {
                        text = category[i].coding[j].display
                    }
                }
            }
            return text
        }
    }

    return (
        <>
            <Paper
                sx={{
                    marginTop: "20px",
                    borderRadius: "8px",
                    marginLeft: "0px",
                    marginRight: "0px",
                    padding: "20px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                }}
                withBorder
            >
                <Title>
                    Observations
                </Title>
                <Table className={classes.table}>
                    <thead className={classes.thead}>
                        <tr>
                            {
                                tableHeaders.map((val) => {
                                    return (
                                        <th key={val}>
                                            {val}
                                        </th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    {
                        <tbody>
                            {
                                observations.map((data: any) => (
                                    <tr key={data.id}>
                                        <td>{data.code?.coding?.[0]?.display}</td>
                                        <td>{getCategory(data.category)}</td>
                                        <td>{formatDateTime(data.issued)}</td>
                                        <td>{formatObservationValue(data)}</td>
                                        <td>{formatDateTime(data.effectiveDateTime as string)}</td>
                                        <td><StatusBadge status={data.status as string} /></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    }
                </Table>
                {(observations?.length === 0 && !isFetching) && (
                    <Center style={{ width: "100%", height: "200px" }}>
                        <Text size="xl" color="dimmed">
                            No results
                        </Text>
                    </Center>
                )}
                {
                    isFetching &&
                    <Center style={{ width: "100%", height: "200px" }}>
                        <Loader />
                    </Center>
                }
            </Paper>
        </>
    )
}